import React, { useEffect } from 'react';
import Style from './SuccessPopup.module.css';

const SuccessPopup = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <>
      {/* Blur backdrop */}
      <div className={Style.backdrop} />

      {/* Popup card */}
      <div className={Style.popup} role="alert">
        <i className={`uil-check-circle ${Style.icon}`} aria-hidden="true" />
        <div className="d-flex flex-column gap-1">
          <h5 className={Style.title}>Success</h5>
          <p className={Style.description}>{message}</p>
        </div>
        <button type="button" className={Style.close} onClick={onClose} aria-label="Close">
          <i className="uil-times" aria-hidden="true" />
        </button>
      </div>
    </>
  );
};

export default SuccessPopup;
